import { AppBar, TitlePortal } from 'react-admin';

export const TopBar = (props: any) => (
  <AppBar {...props} color="primary" elevation={0} sx={{ background: '#0f172a', color: '#e5e7eb' }}>
    <TitlePortal title="Q4uDoc Admin" />
  </AppBar>
);
